module.exports = __webpack_public_path__ + "img/header-diamondJewelryDelicateJewels@2x.6826921.webp";